import { addDoc, collection, doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import toast from "react-hot-toast";

export async function startBotGame({ user, botUser, betAmount, setCurrentGameId, fromQuickPlay }) {
    if (!user?.uid) return toast.error("User not logged in");

    // const userRef = doc(db, "users", user.uid);
    // const userSnap = await getDoc(userRef);
    // const currentBalance = userSnap.data()?.balance || 0;

    // if (currentBalance < betAmount) {
    //     toast.error("Insufficient balance!");
    //     return;
    // }

    // await updateDoc(userRef, {
    //     balance: +(currentBalance - betAmount).toFixed(2),
    // });

    // 💡 Only deduct if NOT coming from quick play (where balance is already deducted)
    if (!fromQuickPlay) {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        const currentBalance = userSnap.data()?.balance || 0;

        if (currentBalance < betAmount) {
            toast.error("Insufficient balance!");
            return;
        }

        await updateDoc(userRef, {
            balance: +(currentBalance - betAmount).toFixed(2),
        });
    }

    const playerX = {
        userId: user.uid,
        username: user.displayName,
        avatar: user.photoURL,
    };

    const playerO = {
        userId: "bot-ai-001", // 👈 fixed for detection
        username: botUser.username,
        avatar: botUser.avatar,
    };

    const gameRef = await addDoc(collection(db, "games"), {
        gameType: "xo",
        playerX,
        playerO,
        players: [playerX.userId, playerO.userId],
        board: Array(9).fill(null),
        turn: "X",
        status: "active",
        winner: null,
        betAmount,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        lastActive: {
            [playerX.userId]: Date.now(),
            [playerO.userId]: Date.now(),
        },
        isBotGame: true,
    });

    setCurrentGameId(gameRef.id);
    toast.success("🤖 Player joined! Game started");
}
